module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="details-wrapper">\n  <div class="boxColumn">\n    <div class="details">\n      <div class="boxColumn-title"><i class="fa fa-envelope"></i> Your Mailing Address</div>\n      <div class="address">' +
((__t = (firstName)) == null ? '' : __t) +
' ' +
((__t = (lastName)) == null ? '' : __t) +
'</div>\n      <div class="address">' +
((__t = (street)) == null ? '' : __t) +
'</div>\n      <div class="address">' +
((__t = (city)) == null ? '' : __t) +
'</div>\n      <div class="state">' +
((__t = (state)) == null ? '' : __t) +
' ' +
((__t = (zip)) == null ? '' : __t) +
'</div>\n    </div>\n  </div>\n  <div class="boxColumn">\n    <div class="details">\n      <div class="boxColumn-title"><i class="fa fa-list-alt"></i> More details</div>\n      <div class="email"><i class="fa fa-at"></i> ' +
((__t = (email)) == null ? '' : __t) +
'</div>\n      <div class="address"><i class="fa fa-phone"></i> ' +
((__t = (phone)) == null ? '' : __t) +
'</div>\n      <div>Promo Code: ' +
((__t = (promoCode)) == null ? '' : __t) +
'</div>\n      <div>Winnings: ' +
((__t = (balance)) == null ? '' : __t) +
'</div>\n    </div>\n  </div>\n</div>\n';

}
return __p
}